(function () {
  'use strict'

  const MODULE_NAME = 'thismoment.common.formly.inputs.email-validate'

  require('angular')
    .module(MODULE_NAME, [
      require('angular-formly'),
      require('angular-formly-templates-bootstrap'),
      require('./email-verify')
    ])
    .run(emailValidateConfig)

  emailValidateConfig.$inject = ['formlyConfig', 'SdkConfig', 'FormlyMessageStrings']
  function emailValidateConfig (formlyConfig, SdkConfig, FormlyMessageStrings) {
    formlyConfig.setType({
      name: 'email-validate',
      extends: 'input',
      controller: emailValidateController,
      defaultOptions: {
        validators: {
          validEmail: {
            expression: function ($viewValue, $modelValue, scope) {
              var value = $modelValue || $viewValue
              if (isValidEmail(value)) {
                return true
              }
              return false
            },
            message: function () {
              return FormlyMessageStrings[SdkConfig.get('language')]['FORMLY.MESSAGE.ERROR'] + ': ' + FormlyMessageStrings[SdkConfig.get('language')]['FORMLY.MESSAGE.EMAIL.INVALID']
            }
          }
        }
      },
      wrapper: ['bootstrapLabel', 'bootstrapHasError']
    })
  }

  emailValidateController.$inject = []
  function emailValidateController () {
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  function isValidEmail (email) {
    return emailRegex.test(email)
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/common/formly/inputs/email-validate.js